module.exports = __webpack_public_path__ + "img/user-data.98c69fea.svg";